import React from 'react';

// Grilla de tarjetas de métricas (icono + label + valor). Mismo estilo que
// usa ver-report-products-sold, extraído acá para reusar en otros reportes
// modernizados (ver-report-order-list, etc.) sin duplicar el CSS.
// stats: [{ label, value, icon: 'fa-...', color: '#rrggbb', delta? }]
// delta (opcional): { text: '▲ 12%', color: '#155724', bg: '#d4edda' } --
// para la comparativa entre periodos (ver-report-order-list, filtro por rango).
export function StatCardsGrid({ stats, columns }) {
    const cols = columns || 3;

    return (
        <>
            <style>{`
              .stat-cards-grid {
                display: grid;
                grid-template-columns: repeat(${cols}, 1fr);
                gap: 12px;
                margin-bottom: 16px;
              }
              @media (max-width: 900px) {
                .stat-cards-grid { grid-template-columns: repeat(2, 1fr); }
              }
              @media (max-width: 550px) {
                .stat-cards-grid { grid-template-columns: 1fr; }
              }
            `}</style>
            <div className="stat-cards-grid">
                {stats.map((s) => (
                    <div
                        key={s.label}
                        style={{
                            minWidth: 0,
                            background: '#fff', border: '1px solid #ebebeb', borderRadius: 10,
                            padding: 14, display: 'flex', alignItems: 'center', gap: 12,
                        }}
                    >
                        <div style={{
                            width: 42, height: 42, borderRadius: '50%', flexShrink: 0,
                            background: s.color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <i className={'fa ' + s.icon} style={{ color: s.color, fontSize: 17 }} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                {s.label}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
                                <div style={{ fontSize: 18, fontWeight: 700, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {s.value}
                                </div>
                                {s.delta && (
                                    <span style={{
                                        fontSize: 11, fontWeight: 600, borderRadius: 8, padding: '1px 6px',
                                        background: s.delta.bg, color: s.delta.color, whiteSpace: 'nowrap',
                                    }}>
                                        {s.delta.text}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default StatCardsGrid;
